import * as React from "react";

const SvgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    fill="none"
    viewBox="0 0 22 22">
    <path
      stroke="#057953"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M5.156 12.173h3.09v6.6c0 .971 1.32 1.43 2.02.696l7.57-7.883c.66-.687.13-1.76-.87-1.76h-3.09v-6.6c0-.972-1.32-1.43-2.02-.697l-7.57 7.884c-.65.687-.12 1.76.87 1.76"></path>
  </svg>
);

export default SvgIcon;
